import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareArrowTopRightCorner: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSquareArrowTopRightCorner"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM11 8.5H14.4395L9.93945 13L11 14.0605L15.5 9.56055V13H17V7H11V8.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareArrowTopRightCorner;
